import { useEffect, useState } from "react";
import { Button, ButtonGroup, Card, Dropdown, Form } from "react-bootstrap";

import { faCog, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CustomDataDto } from "../../types/dto";
import { truncate } from "../../utils";

export const CustomData = ({
	customData,
	openEditModal,
	openDeleteModal,
	onSwitchChanged,
}: {
	customData: CustomDataDto;
	openEditModal: () => void;
	openDeleteModal: () => void;
	onSwitchChanged: (checked: boolean) => void;
}) => {
	const [isEnabled, setIsEnabled] = useState(customData.isEnabled);
	useEffect(() => setIsEnabled(customData.isEnabled), [customData]);

	return (
		<Card
			className={`offeringInstallerCard ${
				isEnabled ? "bg-light" : "bg-white"
			}`}
		>
			<Card.Body className="p-3">
				<Form.Switch
					className="d-inline me-2"
					checked={isEnabled}
					type="switch"
					onChange={() => {
						const newIsEnabled = !isEnabled;
						onSwitchChanged(newIsEnabled);
						setIsEnabled(newIsEnabled);
					}}
				/>
				<span>
					{truncate(`${customData.id} ${customData.name || ""}`, 37)}
				</span>
				<Button
					onClick={openEditModal}
					variant={"primary-hollow"}
					className="float-end p-0 m-0 border-0"
				>
					<span className="icon icon-sm ">
						<FontAwesomeIcon icon={faEdit} />
					</span>
				</Button>
				<div className="ms-1 mt-1 text-black-50">
					{truncate(customData.description ?? "", 50)}
				</div>
			</Card.Body>
		</Card>
	);
};
